// Assessment content and scoring. All wording lives in task_e_content.json.
import content from '../data/task_e_content.json';

export const ASSESSMENT = content.assessment;
export const WHEEL = content.wellbeing_wheel;
export const SPACE = content.my_wellbeing_space;
export const READING = content.reading_progress;
export const CHALLENGE_CONTENT = content.challenges;
export const CHALLENGES = content.challenges.challenges;
export const QUESTIONS = ASSESSMENT.questions;
export const SPOKES = WHEEL.spokes;
export const RECOMMENDATIONS = ASSESSMENT.recommendations;
export const RESULT = ASSESSMENT.result_page;

export const HEALTH_CONDITION_OPTION = QUESTIONS
  .find((q) => q.id === 'q2').options
  .find((o) => o.startsWith('Understand a health condition'));

export const challengeById = (id) => CHALLENGES.find((c) => c.id === id) || null;

export const emptyWheel = () => SPOKES.reduce((acc, s) => ({ ...acc, [s]: 5 }), {});

const RULES = ASSESSMENT.scoring.rules;
const Q2_MAP = RULES.find((r) => r.q2_map).q2_map;
const FLAGS = RULES.find((r) => r.flags).flags;

// Top 3 priorities: +3 chosen in q2, +2 slider 4 or lower, +2 once for need flags.
// Ties go to the lower slider, then to the order of the areas in q1.
export const computePriorities = (answers) => {
  const wheel = answers.q1 || {};
  const scores = SPOKES.reduce((acc, s) => ({ ...acc, [s]: 0 }), {});

  (answers.q2 || []).forEach((choice) => {
    const area = Q2_MAP[choice];
    if (area) scores[area] += 3;
  });

  SPOKES.forEach((area) => {
    if (Number(wheel[area]) <= 4) scores[area] += 2;
  });

  const flagged = new Set();
  Object.entries(FLAGS).forEach(([key, area]) => {
    const [qid, value] = key.split('=');
    if (answers[qid] === value) flagged.add(area);
  });
  flagged.forEach((area) => { scores[area] += 2; });

  return SPOKES
    .map((area, index) => ({ area, score: scores[area], slider: Number(wheel[area] ?? 5), index }))
    .sort((a, b) => (b.score - a.score) || (a.slider - b.slider) || (a.index - b.index))
    .slice(0, ASSESSMENT.scoring.top_n)
    .map((p) => p.area);
};

export const isAnswered = (question, answers) => {
  const value = answers[question.id];
  if (question.type === 'sliders') return !!value;
  if (question.type === 'multi') return Array.isArray(value) && value.length > 0;
  return !!value;
};

export const wantsConditionGuides = (answers) => (answers.q2 || []).includes(HEALTH_CONDITION_OPTION);
export const needsSupport = (answers) => answers.q8 === 'Most days';
